import styled from 'styled-components';

export const SummaryContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const SummaryMain = styled.div`
  border: 1px solid #e4e4e4;
  padding: 20px;
  margin-right: 2%;
  margin-top: 1%;
  box-shadow: 0px 0px 8px #e4e4e4;
`;

export const SummaryItemMain = styled.div`
  padding: 10px 0;
  font-size: 14px;
`;

export const SummaryItemLabel = styled.div`
  font-weight: 700;
  display: inline-block;
  width: 90%;
`;
